import React, { useEffect } from 'react';
import { ShieldCheck, Mail } from 'lucide-react';

export const PrivacyPolicyPage: React.FC = () => {
  useEffect(() => {
    document.title = 'Aviso de Privacidad — Doña Blanca';
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="bg-[#FAF8F5] min-h-screen py-14 sm:py-20 lg:py-24">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header institucional */}
        <div className="text-center max-w-3xl mx-auto space-y-4 mb-10 sm:mb-12">
          <span className="text-xs uppercase font-extrabold tracking-widest text-[#97472E] bg-[#F1ECE1] px-3.5 py-1.5 rounded-full inline-flex items-center gap-1.5">
            <ShieldCheck className="w-3.5 h-3.5 text-[#97472E]" />
            <span>Documento Oficial</span>
          </span>
          <h1 className="font-heading font-black text-3xl sm:text-4xl lg:text-5xl text-[#001557] tracking-tight">
            AVISO DE PRIVACIDAD
          </h1>
          <p className="text-sm sm:text-base text-gray-600">
            Restaurante Doña Blanca · Protección de Datos Personales
          </p>
        </div>

        {/* Tarjeta con el texto legal íntegro */}
        <div className="bg-white rounded-2xl border border-[#E5E0D8] shadow-sm p-6 sm:p-10 lg:p-12 text-stone-800 leading-relaxed space-y-6 text-sm sm:text-base">
          <p>
            En cumplimiento con la Ley Federal de Protección de Datos Personales en Posesión de Particulares, el restaurante Doña Blanca (en adelante, “el Responsable”) hace de su conocimiento que es responsable de recabar sus datos personales, del uso que se les dé a los mismos y de su protección.
          </p>

          <div className="space-y-2">
            <p className="font-semibold text-stone-900">
              Los datos personales que el Responsable recopila de usted son los siguientes:
            </p>
            <ul className="list-disc list-inside space-y-1 pl-2 text-stone-700">
              <li>Nombre completo</li>
              <li>Correo electrónico</li>
              <li>Número telefónico</li>
              <li>Dirección de domicilio</li>
              <li>Fecha de nacimiento</li>
              <li>Nacionalidad</li>
            </ul>
          </div>

          <div className="space-y-2">
            <p>
              La finalidad principal de recopilar estos datos es para poder brindarle el servicio de restaurante, incluyendo la gestión de reservas y la atención al cliente. Adicionalmente, el Responsable utilizará estos datos para:
            </p>
            <ul className="list-disc list-inside space-y-1 pl-2 text-stone-700">
              <li>Enviar información sobre promociones y eventos del restaurante</li>
              <li>Realizar encuestas de satisfacción</li>
              <li>Realizar análisis estadísticos y de mercado</li>
            </ul>
          </div>

          <p>
            El tratamiento de sus datos personales se realizará con estricto apego a los principios de licitud, consentimiento, información, calidad, finalidad, lealtad, proporcionalidad y responsabilidad en términos de la legislación aplicable.
          </p>

          <p>
            El Responsable se compromete a no transferir sus datos personales a terceros sin su consentimiento previo y por escrito, salvo en los casos en que sea necesario para cumplir con obligaciones legales o para proteger los derechos del Responsable.
          </p>

          <p>
            Usted tiene derecho a conocer qué datos personales del Responsable tiene en su posesión, así como a solicitar su corrección en caso de que sean inexactos o incompletos, su cancelación en caso de que considere que no se requieren para las finalidades establecidas en el presente aviso de privacidad, o su oposición al tratamiento de los mismos para fines específicos.
          </p>

          <div className="p-4 rounded-xl bg-[#FAF8F5] border border-[#E8E4DC] flex items-start gap-3">
            <Mail className="w-5 h-5 text-[#001557] shrink-0 mt-0.5" />
            <p className="text-stone-800">
              Si desea ejercer alguno de sus derechos, o tiene alguna duda o comentario respecto a este aviso de privacidad, por favor contáctenos en{' '}
              <a
                href="mailto:dblanca.restaurant@gmail.com"
                className="font-bold text-[#001557] underline hover:text-[#97472E] transition-colors"
              >
                dblanca.restaurant@gmail.com
              </a>
              .
            </p>
          </div>

          <p>
            Este aviso de privacidad puede sufrir cambios en el futuro, en cuyo caso se le informará de manera oportuna a través de nuestro sitio web o mediante cualquier otro medio de comunicación que el Responsable determine para tal fin.
          </p>

          <div className="pt-6 border-t border-[#EBE7DF] flex flex-col sm:flex-row sm:items-center sm:justify-between text-xs text-stone-500 gap-2">
            <span>Fecha de última actualización: 28 abril 2023</span>
            <span className="font-semibold text-stone-600">Restaurante Doña Blanca</span>
          </div>
        </div>
      </div>
    </div>
  );
};
